// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"0a8c749b","203":"842ffced","453":"c46c10cd","520":"6796ea54","598":"5cb35f68","672":"4e31b03a","700":"092c362c","811":"3227ff1f","829":"92a90923","901":"1ff2166d"}[chunkId] + ".chunk.js";
};